// Module
var code = "<dialog-template class=\"flow-error-viewer flow-popup\"> <template v-slot:content> <disclaimer/> </template> <template v-slot:footer> <button type=\"button\" class=\"plain-button\" @click=\"closeDialog()\">{{ $t('buttons.close') }}</button> </template> </dialog-template>";
// Exports
module.exports = code;